"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getResolvedPath = void 0;
function getResolvedPath(path) {
    const basePath = process.env.NEXT_PUBLIC_BASE_PATH;
    const prefixedPath = path && !path.startsWith('/') ? `/${path}` : path;
    if (!basePath) {
        return prefixedPath;
    }
    if (prefixedPath === '/' || !prefixedPath) {
        return basePath;
    }
    return `${basePath}${prefixedPath}`;
}
exports.getResolvedPath = getResolvedPath;
//# sourceMappingURL=utils.js.map